import { CommonModule } from "@angular/common";
import { Component, OnInit } from "@angular/core";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { debounceTime, Observable } from "rxjs";
import { LoaderService } from "../../../core/services/loader.service";

@Component({
  selector: "app-loading-spinner",
  standalone: true,
  imports: [CommonModule, MatProgressSpinnerModule],
  templateUrl: "./loading-spinner.component.html",
  styleUrl: "./loading-spinner.component.scss",
})
export class LoadingSpinnerComponent implements OnInit {
  showPageLoadSpinner = false;
  visibility$: Observable<boolean> = new Observable<boolean>();

  constructor(private loaderService: LoaderService) {}

  ngOnInit(): void {
    this.onLoaderActiveChangeUpdateSpinnerVisibility();
  }

  private onLoaderActiveChangeUpdateSpinnerVisibility(): void {
    this.loaderService.visibility$.pipe(debounceTime(200)).subscribe({
      next: (value: boolean) => {
        this.showPageLoadSpinner = value;
      },
    });
  }
}
